var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4146_3840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM14.8213 7.73875C14.8936 7.63911 14.9457 7.52619 14.9744 7.40643C15.0032 7.28667 15.0081 7.16242 14.9888 7.04078C14.9695 6.91913 14.9265 6.80247 14.8622 6.69746C14.7978 6.59245 14.7134 6.50114 14.6138 6.42875C14.5141 6.35636 14.4012 6.3043 14.2814 6.27555C14.1617 6.2468 14.0374 6.24192 13.9158 6.26119C13.7941 6.28046 13.6775 6.3235 13.5725 6.38785C13.4674 6.4522 13.3761 6.53661 13.3037 6.63625L8.95 12.6237L6.6 10.2738C6.51348 10.1843 6.40999 10.1129 6.29559 10.0638C6.18119 10.0147 6.05816 9.98892 5.93368 9.9879C5.8092 9.98687 5.68576 10.0107 5.57057 10.0578C5.45538 10.105 5.35074 10.1747 5.26275 10.2628C5.17477 10.3508 5.10521 10.4555 5.05812 10.5708C5.01104 10.686 4.98738 10.8095 4.98852 10.934C4.98966 11.0584 5.01558 11.1814 5.06476 11.2958C5.11395 11.4101 5.18542 11.5136 5.275 11.6L8.4 14.725C8.49578 14.8208 8.6112 14.8948 8.73831 14.9417C8.86541 14.9887 9.00118 15.0075 9.13626 14.9969C9.27135 14.9863 9.40253 14.9466 9.52079 14.8805C9.63904 14.8143 9.74155 14.7233 9.82125 14.6138L14.8213 7.73875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4146_3840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.1a28f324d4eb4d1b73300a76326ae8ed.svg";
export { ForwardRef as ReactComponent };